import PropTypes from 'prop-types';
import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import Modal from '../../../../../../../components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-duotone-svg-icons';
import { faCircleQuestion, faUpload } from '@fortawesome/pro-solid-svg-icons';
import CustomToast from '../../../../../../../components/Toast';
import { useUploadDocumentMutation } from '../../../../../../../features/authentication/teacherDocumentApiSlice';
import ActivityTypes from '../../../../../../../enums/activityTypes';
import { useCreateResourceSetMutation } from '../../../../../../../features/authentication/qSetApiSlice';
import NewResourceSetNameModal from './newResourceSetNameModal';
import { useNavigate } from 'react-router';

const AddFileModal = ({ showModal, setShowModal, setId, onFileAdded }) => {
  const [fileTitle, setFileTitle] = useState('');
  const [files, setFiles] = useState(null);
  const [uploadDocument, { isLoading: uploadIsLoading }] = useUploadDocumentMutation();
  const [createResourceSet, { isLoading: resourceIsLoading }] = useCreateResourceSetMutation();
  const [showNewSetNameModal, setShowNewSetNameModal] = useState(false);
  const [newSetName, setNewSetName] = useState(fileTitle);
  const navigate = useNavigate();

  useEffect(() => {
    setFileTitle('');
    setFiles(null);
  }, [showModal]);

  const handleDocumentUpload = async (isNewSet) => {
    try {
      let formData = new FormData();
      formData.append('file', files);
      formData.append('setId', parseInt(setId));
      formData.append('description', fileTitle);

      var result = await uploadDocument(formData).unwrap();
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Url || result.error.data.errors.Description, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Resource Created Successfully.', 'success');
        setShowModal(false);
        if (isNewSet) {
          navigate(`${setId}`)
        } else if (onFileAdded) {
          onFileAdded();
        }
      }
    } catch (error) {
      CustomToast('Failed To Create Resource.', 'error');
      console.log(error);
    }
  };

  const handleCreateNewResourceSet = async (e) => {
    e.preventDefault();

    const option = {
      description: newSetName,
      activityType: ActivityTypes.Documents
    };

    try {
      const result = await createResourceSet(option);
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Description, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        setId = result.data;
        handleDocumentUpload(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    setFiles(e.target.files[0]);
  };

  const handleTitleValidation = (event) => {
    var inputValue = event.target.value;

    if (inputValue.length > 50) {
      event.target.setCustomValidity('Title must not exceed 50 characters!');
    } else {
      event.target.setCustomValidity('');
    }
  };

  return (
    <>
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        titleName='Upload File'
        contentWidth='40%'>
        <div className='d-flex flex-row align-items-center'>
          <FontAwesomeIcon icon={faCircleInfo} style={{ '--fa-primary-color': '#63d0ff', '--fa-secondary-color': '#d5f2ff', fontSize: '2em', marginRight: '0.35em' }} />
          <div>Select a PDF, PowerPoint, Word, MP3 or MP4 file that is less than 500 megabytes in size.</div>
        </div>

        <Form className='d-flex flex-column gap-4 my-4' onSubmit={(e) => { e.preventDefault(); setId > 0 ? handleDocumentUpload(false) : setShowNewSetNameModal(true) }}>
          <Form.Group id='title' className='w-100'>
            <Form.Label>Title</Form.Label>
            <Form.Control disabled={uploadIsLoading || resourceIsLoading} type='text' className='w-100' required defaultValue={fileTitle} onInput={handleTitleValidation} onChange={(e) => setFileTitle(e.target.value)} />
          </Form.Group>

          <div className='pb-4'>File&ensp;
            <OverlayTrigger
              key={'file-upload-info'}
              placement='right'
              overlay={
                <Tooltip className='initial-assignment-tooltip'>
                  Select a PDF, PowerPoint, Word, MP3 or MP4 file that is less than 500 megabytes in size.
                </Tooltip>
              }>
              <FontAwesomeIcon className='circle-question' icon={faCircleQuestion} />
            </OverlayTrigger>
            <div className='upload_xml pt-2'>
              <div className='row mb-3'>
                <div className='col-12'>
                  <div
                    className='custom-upload position-relative d-flex flex-column justify-content-center align-items-center p-5 text-center'
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      e.dataTransfer.dropEffect = 'copy';
                    }}
                    onDragEnter={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setFiles(e.dataTransfer.files[0]);
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setFiles(e.dataTransfer.files[0]);
                    }}>
                    <input
                      onChange={handleFileUpload}
                      className='form-control position-absolute w-100 h-100 top-0 start-0'
                      type='file'
                    />
                    <span className='d-block mb-2'>
                      {' '}
                      <FontAwesomeIcon icon={faUpload} />
                    </span>
                    <p className='mb-0'>
                      <strong>Click to upload</strong> or Drag and drop file
                    </p>
                    {files && (
                      <div className='mt-3'>
                        <p>{files.name}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex flex-row justify-content-end gap-2 mt-3'>
            <Button style={{ minWidth: '90px' }} variant='castleGray' onClick={() => setShowModal(false)}>Cancel</Button>
            <Button disabled={uploadIsLoading || resourceIsLoading} style={{ minWidth: '90px' }} variant='castleRed' type='submit'>{uploadIsLoading || resourceIsLoading ? 'Saving...' : 'Save'}</Button>
          </div>
        </Form>

      </Modal>

      <NewResourceSetNameModal
        showModal={showNewSetNameModal}
        setShowModal={setShowNewSetNameModal}
        newSetName={newSetName}
        setNewSetName={setNewSetName}
        handleCreateNewResourceSet={handleCreateNewResourceSet}
      />
    </>
  );
};

AddFileModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  handleSave: PropTypes.func
};

export default AddFileModal;